import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'multiSplice',
})
export class MultiSplicePipe implements PipeTransform {
	transform(array: any[], index: number[]): any[] {
		index.sort(function (a, b) {
			return b - a;
		});

		for (const index_ of index) {
			array.splice(index_, 1);
		}

		return array;
	}
}
